export const NO_CODE = 'NO_CODE'

/**
 * The Basic Error object. Provides information about an error that occurred in the SDK.
 * @public
 * @static
 * @typedef {Object} BasicError
 * @memberof api
 * @property {string} code The code of the error. If no code is known, this will be 'NO_CODE'.
 * @property {string} message A human-readable message to describe the error. If no message is known, this will be 'An error occurred'.
 */

export {
  authCodes,
  callCodes,
  callHistoryCodes,
  groupsCodes,
  messagingCodes,
  mwiCodes,
  sipEventCodes,
  clickToCallCodes,
  bridgeCodes,
  subscriptionCodes,
  presenceCodes,
  usersCodes,
  webrtcCodes
} from './codes'

export default class BasicError {
  constructor ({ message, code }) {
    this.name = 'BasicError'
    this.code = code || NO_CODE
    this.message = message ? `${message}` : 'An error occurred.'
  }
}
